import { MapBox } from 'components/Core/MapBox/MapBox';
import { observer } from 'mobx-react-lite';
import { useStore } from 'hooks/useRootStore';
import styles from './mapViewPopUp.module.scss';

export const MapViewPopUp = observer(function () {
  const {
    popUpStore: { location },
  } = useStore();

  return location ? <MapBox locations={[location]} draggableMarkers={false} classNameProp={styles.mapBox} /> : null;
});
